import { useState } from 'react'
import { EasyIcon } from 'src/components'

// 全屏按钮
const FullScreen = () => {
  const [isFull, setIsFull] = useState(false)

  const handleFullScreen = () => {
    const target = document.getElementsByClassName('main')[0]
    if (document.fullscreenElement) {
      document?.exitFullscreen()
    } else {
      target?.requestFullscreen()
    }
    setIsFull(!document.fullscreenElement)
  }

  return (
    <EasyIcon
      title={isFull ? '取消全屏' : '全屏'}
      type={isFull ? 'FullscreenExitOutlined' : 'FullscreenOutlined'}
      onClick={handleFullScreen}
    />
  )
}

export default FullScreen